const pushGTMDataLayer = (dataLayer) => {
    window.dataLayer.push({
        ...dataLayer
    });
};
export default pushGTMDataLayer;
